import { render, staticRenderFns } from "./DataPreferences.vue?vue&type=template&id=06355fdf&scoped=true"
import script from "./DataPreferences.vue?vue&type=script&lang=js"
export * from "./DataPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06355fdf",
  null
  
)

export default component.exports